module.exports = __webpack_public_path__ + "waveform-top-left-cool.4a07929.png";